import { render, staticRenderFns } from "./ViewClientGroup.vue?vue&type=template&id=f40794bc"
import script from "./ViewClientGroup.vue?vue&type=script&lang=js"
export * from "./ViewClientGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports